<script lang="ts" setup>
  defineProps<{ text: string }>();
</script>

<template>
  <p>{{ text }}</p>
</template>

<style scoped>
  p {
    background: linear-gradient(var(--color-logo-from), var(--color-logo-to));
    background-clip: text;
    font-family: var(--font-logo);
    font-style: italic;
    font-weight: var(--font-weight-logo);
    margin: 0;
    -webkit-text-fill-color: transparent;
  }
</style>
